import React, { Image } from 'react-native'

import { images } from '@zet/assets/images'
import VideoBanner from '@zet/common/components/videoBanner'
import { MY_TEAMS_ADVISOR } from '@zet/constants'
import { B5, Icon, Stack, colors as zetColors } from '@zet/design-system'
import { APP_NAME } from '@zet/end-points'
import { useSpecificAppComms } from '@zet/feature-user/api/appComms/hooks'
import { i18n } from '@zet/localization'

export default function EmptyCustomers() {
  const { data: videoData } = useSpecificAppComms('appVideos')

  return (
    <Stack className="bg-grays-30 mb-3">
      <Stack className="mx-3 mt-16 items-center">
        <Image
          style={{
            width: 100,
            height: 100,
          }}
          resizeMode="contain"
          source={require('../../../assets/images/add.png')}
        />
        {APP_NAME !== MY_TEAMS_ADVISOR ? (
          <B5 className="text-grays-60 mt-3 ">
            {i18n.t('myCustomers.validFor')}
          </B5>
        ) : (
          <></>
        )}
      </Stack>
      <Stack className="z-10 mx-3 mt-3 h-[168] overflow-hidden rounded-xl">
        {APP_NAME !== MY_TEAMS_ADVISOR ? (
          <VideoBanner
            image={images.addCustomerThumbnail}
            icon={
              <Icon type="VideoFilled" size={53} color={zetColors.error[100]} />
            }
            classname="absolute"
            eventName="click_action"
            eventPayload={{ item_name: 'add_customer_watch_video' }}
            videoData={videoData?.zetMyCustomers}
          />
        ) : (
          <></>
        )}
      </Stack>
    </Stack>
  )
}
